module.exports = __webpack_public_path__ + "static/img/5.580905d.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/5/5.png
// module id = 249
// module chunks = 0